import Bag from './Bag'

export default class Tiptap extends Bag<{ editing: boolean }> {
  state = this.getState({
    editing: false,
  })
}
